import { render, staticRenderFns } from "./VireedPage.vue?vue&type=template&id=6c4fbcce&"
import script from "./VireedPage.vue?vue&type=script&lang=js&"
export * from "./VireedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports